var map = {
	"./illustration-access-denied-darkmode.svg": "qQ1V",
	"./illustration-access-denied.svg": "WxFr",
	"./illustration-awaiting-verification.svg": "ykH/",
	"./illustration-expired-link-darkmode.svg": "pjJT",
	"./illustration-expired-link.svg": "LWHq",
	"./illustration-not-found-darkmode.svg": "F+nX",
	"./illustration-not-found.svg": "CRyh",
	"./illustration-writing-elite.svg": "P1Rj"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "nhgR";